import { tourSteps } from '../labels';

export const startTour = ({inEnglish=true}={}) => 
{
    const steps = tourSteps.map(step =>
    {
        const {title, description} = inEnglish ? step.english : step.nepali;
        return {
            element: step.selector ? document.querySelector(step.selector) : null,
            intro: `
                <strong>${title}</strong>
                <br>
                <span style="font-size: 13px;">${description}</span>`,
            position: step.position,
        };
    });
    
    window.introJs().setOptions({
        exitOnEsc: false,
        showProgress: true,
        showStepNumbers: true,
        showBullets: true,
        skipLabel: inEnglish ? 'Skip' : 'छोड्नुहोस्',
        nextLabel: inEnglish ? 'Next >' : 'अर्को >',
        prevLabel: inEnglish ? '< Prev' : '< पछाडि',
        doneLabel: inEnglish ? 'Done' : 'सकियो',
        steps: steps,
    }).start(); // start the guide
};